const stripHtml = (html) => {
    const withBreaks = (html || '').replace(/<\/(p|div|h[1-6]|li)>|<br\s*\/?>/gi, ' ')
    const el = document.createElement('div')
    el.innerHTML = withBreaks
    return (el.textContent || '').replace(/\s+/g, ' ').trim()
}

const setMeta = (name, content) => {
    if (!content) return

    let tag = document.querySelector(`meta[property="${name}"]`)

    if (!tag) {
        tag = document.createElement('meta')
        tag.setAttribute('property', name)
        document.head.appendChild(tag)
    }

    tag.setAttribute('content', content)
}

/**
 * Updates the page title and og: tags from already-fetched data (e.g. a
 * product) instead of triggering a second, server-side fetch of the same
 * resource just for SEO purposes.
 */
export const setOgTags = ({ title, description, image }) => {
    if (title) document.title = title

    setMeta('og:title', title)
    setMeta('og:description', stripHtml(description)?.slice(0, 200))
    setMeta('og:image', image)
}
